import { render, staticRenderFns } from "./HistoryDatasetDetails.vue?vue&type=template&id=65bec6d4&"
import script from "./HistoryDatasetDetails.vue?vue&type=script&lang=js&"
export * from "./HistoryDatasetDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports